import React from 'react';
import T from 'prop-types';
import { Translation, Optional } from 'srcAlias/client/locale';
import translations from 'contentAlias';
import { get } from 'lodash-es';
import {
  Paragraph,
  Expander,
  UnorderedList,
  ListItem,
  Link,
} from '@piggybank/core';

export const ReviewDetailsPageNeedsSomethingExpander = (startExpanded) => {
  return (
    <Expander
      startExpanded={get(startExpanded, 'startExpanded', true)}
      title={<Translation path="reviewExpandTitle" />}
      name="needToChangeSomething"
    >
      <Paragraph>
        <Translation path="reviewExpandInfoHeading1" />

        <UnorderedList>
          <ListItem>
            <Translation path="reviewExpandInfoPara1" />
          </ListItem>
          <Optional>
            <ListItem>
              <Translation path="reviewExpandInfoPara2" />
            </ListItem>
          </Optional>
          <ListItem>
            <Translation path="reviewExpandInfoPara2Part1" />
            <Link
              href={translations.customer.reviewDetails.linkUrl}
              external
              textMap={{ newWindow: <Translation path="textMap" /> }}
              name="updateProfileDownloadFormLink"
            >
              <Translation path="reviewExpandInfoPara2Part2" />
            </Link>
            <Translation path="reviewExpandInfoPara2Part3" />
          </ListItem>
        </UnorderedList>
        <Optional>
          <Translation path="reviewExpandInfoHeading2" />
        </Optional>
      </Paragraph>
    </Expander>
  );
};

ReviewDetailsPageNeedsSomethingExpander.propTypes = {
  pageConfigValues: T.object,
};
